module.exports = "<div class=social-linkedin-button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/social/obsSocialLinkedinButton.html
// module id = 3581
// module chunks = 12